"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GRID_SPARK_LINE_CHART_COL_DEF = exports.COLORS = void 0;
var _Cell = require("../components/Cell");
var _BarChart = require("@mui/x-charts/BarChart");
var _ChartContainer = require("@mui/x-charts/ChartContainer");
var _jsxRuntime = require("react/jsx-runtime");
var COLORS = exports.COLORS = ['#4f77a0', '#F06292', '#FFB74D', '#81C784', '#BA68C8', '#058DC7', '#DC143C', '#648C11', '#8A2BE2', '#FF7518', '#7F77EA', '#0EB05C', '#902C2F', '#F78072', '#C7B590', '#FFCC33', '#16D9EB', '#F05D0E', '#D9BB41', '#3399FF'];
var GRID_SPARK_LINE_CHART_COL_DEF = exports.GRID_SPARK_LINE_CHART_COL_DEF = {
  align: 'right',
  headerAlign: 'right',
  disableText: true,
  renderCell: function renderCell(params) {
    var formattedValue = params.formattedValue,
      colDef = params.colDef;
    var value = formattedValue.value,
      compareValue = formattedValue.compareValue;
    var _colDef$placeholder = colDef.placeholder,
      placeholder = _colDef$placeholder === void 0 ? '-' : _colDef$placeholder;
    var xAxisData = Array(Math.max((value === null || value === void 0 ? void 0 : value.length) || 0, (compareValue === null || compareValue === void 0 ? void 0 : compareValue.length) || 0)).fill(null).map(function (v, i) {
      return i;
    });
    var series = [];
    if (value !== null && value !== void 0 && value.length) {
      series.push({
        data: value,
        type: 'bar',
        stack: 'sparkline',
        id: 'base',
        color: COLORS[0]
      });
    }
    if (compareValue !== null && compareValue !== void 0 && compareValue.length) {
      series.push({
        data: compareValue,
        type: 'bar',
        stack: 'sparkline',
        id: 'compare',
        color: COLORS[1]
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Cell.CellWrapper, {
      "data-cy": _Cell.dataCy,
      children: series !== null && series !== void 0 && series.length ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChartContainer.ChartContainer, {
        height: 48,
        width: colDef.width,
        margin: {
          top: 4,
          right: 0,
          bottom: 4,
          left: 0
        },
        series: series,
        xAxis: [{
          scaleType: 'band',
          data: xAxisData
        }],
        disableAxisListener: true,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_BarChart.BarPlot, {
          skipAnimation: true
        })
      }) : placeholder
    });
  }
};